import { useEffect } from "react";
import { useLocation } from "react-router-dom";

interface IProps {

}

export function ScrollToTop(props: IProps) {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}